import {Alert, Modal} from 'react-bootstrap'
import React, {useContext, useEffect, useState} from 'react'
import FormDateTimePicker from '../lib/FormDateTimePicker'
import config from '../config'
import FileSaver from 'file-saver'
import moment from 'moment-timezone'
import {RootContext} from '../contexts/RootContext'

const InstrumentDataModal = ({ show, onClose, resource }) => {
  const [formState, setFormState] = useState({})
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState([])
  const { showMessage } = useContext(RootContext)

  useEffect(() => {
    setFormState({
      startDate: moment().subtract(1, 'days').startOf('day').format(),
      endDate: moment().endOf('day').format(),
    })
  }, [resource]);

  const handleInputChange = (ev) => {
    const name = ev.target.name
    let value = ev.target.value
    setFormState({...formState, [name]: value})
  }

  const download = async () => {
    let fetchConfig = {
      method: 'GET',
      headers: {
        'Accept': 'text/csv',
        'Content-Type': 'text/csv',
        'Authorization': `Bearer ${JSON.parse(window.localStorage.getItem('auth') || '{}').jwt}`
      }
    }
    const from = formState.startDate
    const to =  formState.endDate
    let url = `${config.apiUrl}/instrument_data_exports/${resource.id}?from=${from}&to=${to}`

    setLoading(true)
    setErrors([])

    try {
      const response = await fetch(url, fetchConfig)
      if (!response.ok) {
        const body = await response.json()
        setErrors(JSON.parse(body.errors).data)
        return
      }
      const parts =  response.headers.get('content-disposition').split(';').map(part => part.trim())
      const filename = parts.find(part => part.startsWith('filename=')).split('=')[1].replace(/"/g, '')
      const blob = await response.blob()
      FileSaver.saveAs(blob, filename)
      onClose()
      showMessage(`Data exported: ${filename}`)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        {resource &&
          <Modal.Title>
            Export data
          </Modal.Title>}
      </Modal.Header>
      <Modal.Body>
        {errors.length > 0 && (
          <Alert variant="danger">
            {errors.map((error, index) => (
              <p key={index}>{error}</p>
            ))}
          </Alert>
        )}
        <h5>{resource && resource.name}</h5>
        {resource && resource.group && (
          <div>
            <p>Export all child instrument data as CSV files in ZIP container for given time range</p>
            <p><i>Note: this may take a while</i></p>
          </div>
        )}
        {resource && !resource.group && (
          <p>Export data as CSV file for given time range</p>
        )}
        <FormDateTimePicker name="startDate" value={formState.startDate} onChange={handleInputChange} />
        <FormDateTimePicker name="endDate" value={formState.endDate} onChange={handleInputChange} />
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Cancel
        </button>
        <button type="button" className="btn btn-primary" onClick={download} disabled={loading}>
          {loading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
          <span>Download</span>
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default InstrumentDataModal
